module.exports = __webpack_public_path__ + "img/50.f94c8d23.jpg";